import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ExternalCallbackService} from '../../services/external-callback.service';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {WebSocketService} from '../../../../../core/service/web-socket-service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

import * as _ from 'underscore';

@Component({
  selector: 'app-resend-leads-external-callback',
  templateUrl: './resend-leads-external-callback.component.html',
  styleUrls: ['./resend-leads-external-callback.component.scss']
})
export class ResendLeadsExternalCallbackComponent implements OnInit {

    data: Object;
    formSearch: FormGroup;

    loading: boolean = false;
    numLeadsToResend: number;

    progressData: Object = { 'width' : '0%', 'widthValue' : '0', 'last_request' : '', 'last_response': '' };
    protected counter: number = 0;

    constructor(private fb: FormBuilder, private externalCallbackService: ExternalCallbackService, private datesParser: DatesParserService, private websocket: WebSocketService, private alertaService: AlertaService) {
        this.formSearch = this.fb.group({
            'ext_lead_start_sent_date' : new FormControl(),
            'ext_lead_end_sent_date' : new FormControl(),
            'ext_lead_start_queued_date' : new FormControl(),
            'ext_lead_end_queued_date' : new FormControl(),
            'ext_lead_response' : new FormControl(),
            'ext_lead_response_code' : new FormControl(),
            'response' : new FormControl(),
            'status_like' : new FormControl(),
            'requeue' : new FormControl('0')
        });
    }

    resendLeads(): void {

        this.resetProgress();

        this.loading = true;
        const query = this.datesParser.cleanDates(this.formSearch.value, ['ext_lead_start_sent_date', 'ext_lead_end_sent_date', 'ext_lead_start_queued_date', 'ext_lead_end_queued_date'], false);

        this
            .externalCallbackService
            .countLeadsResend(this.data['pk'], query)
            .subscribe(
                (result) => {
                    this.loading = false;
                    this.numLeadsToResend = result['count'];
                    this
                        .alertaService
                        .addAlert('confirm', this.numLeadsToResend + ' leads are going to be resent. Are you sure?')
                        .then(
                            (result: any) => {
                                console.log(result);
                                if(result['value']){
                                    this.externalCallbackService.resendLeads(this.data['pk'], query).subscribe(

                                    )
                                }
                            }
                        )
                }
            )
        ;
    }

    resetProgress(): void {
        this.numLeadsToResend = 0;
        this.progressData = { 'width' : '0%', 'widthValue' : '0', 'last_request' : '', 'last_response': '' };
        this.counter = 0;
    }

    ngOnInit() {
        this.websocket.message.subscribe(
            (msg: Object) => {
                if(msg.hasOwnProperty('type') && msg['type'] == 'external_callback_' + this.data['pk'] + '_leads_resent'){
                    this.counter++;
                    this.progressData['widthValue'] = ((this.counter / this.numLeadsToResend) * 100).toFixed(2);
                    this.progressData['width'] = this.progressData['widthValue'] + '%';
                    this.progressData['last_request'] = msg['data']['request'] + ' --> ' + msg['data']['status'];
                    //this.progressData['last_response'] = msg['data']['response'];
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/resend-leads-external-callback/resend-leads-external-callback.component.ts